/* La Fleury — lista de deseos sin cuentas: se guarda en el navegador (localStorage).
   - Corazón de la cabecera: enlace a /pages/wishlist, con un puntito cuando hay algo guardado.
   - Botón [data-lf-wish="handle"] en la ficha: guarda o quita el producto.
   - [data-lf-wishlist] en la página: pinta las piezas guardadas con /products/<handle>.js. */
(function () {
  if (window.__lfWish) return;
  window.__lfWish = true;
  var KEY = 'lf-wishlist';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function has(h) { return read().indexOf(h) > -1; }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-lf-wish-count]').forEach(function (el) {
      el.hidden = list.length === 0;
      el.textContent = list.length ? String(list.length) : '';
    });
    document.querySelectorAll('[data-lf-wish-link]').forEach(function (el) {
      el.classList.toggle('is-active', list.length > 0);
    });
    document.querySelectorAll('[data-lf-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-lf-wish')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      var label = btn.querySelector('[data-lf-wish-label]');
      if (label) label.textContent = on ? (btn.getAttribute('data-on') || 'Saved to wishlist') : (btn.getAttribute('data-off') || 'Add to wishlist');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lf-wish]');
    if (!btn) return;
    e.preventDefault();
    var h = btn.getAttribute('data-lf-wish');
    var list = read();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list);
    var box = btn.closest('[data-lf-wishlist-item]');
    if (box && i > -1) box.remove(), emptyState();
  });

  // La ficha de un cojín se cambia sin recargar (lf-pair.js): volver a pintar los botones.
  document.addEventListener('lf:swap', sync);

  function money(cents, fmt) {
    var n = (cents / 100);
    var dot = n.toFixed(2), comma = dot.replace('.', ',');
    return (fmt || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount\s*\}\}/, dot)
      .replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var root;
  // raíz del idioma en el que está la clienta: «/» o «/es/»
  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function emptyState() {
    if (!root) return;
    var grid = root.querySelector('[data-lf-wishlist-grid]');
    var empty = root.querySelector('[data-lf-wishlist-empty]');
    var n = grid ? grid.children.length : 0;
    if (empty) empty.hidden = n > 0;
  }
  function render() {
    root = document.querySelector('[data-lf-wishlist]');
    if (!root) return;
    var grid = root.querySelector('[data-lf-wishlist-grid]');
    var fmt = root.getAttribute('data-money-format');
    var list = read();
    grid.innerHTML = '';
    if (!list.length) return emptyState();
    Promise.all(list.map(function (h) {
      return fetch(RAIZ + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var alive = [];
      items.forEach(function (p) {
        if (!p) return;
        alive.push(p.handle);
        var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=700' : p.featured_image + '?width=700') : '';
        var li = document.createElement('li');
        li.className = 'lf-card lf-wishlist__item';
        li.setAttribute('data-lf-wishlist-item', '');
        li.innerHTML =
          '<a class="lf-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
            (img ? '<img class="lf-card__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="lf-card__info">' +
            '<a class="lf-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="lf-card__price">' + esc(money(p.price, fmt)) + '</span>' +
            '<button type="button" class="lf-wishlist__remove" data-lf-wish="' + esc(p.handle) + '" aria-pressed="true">' + esc(root.getAttribute('data-remove-label') || 'Remove') + '</button>' +
          '</div>';
        grid.appendChild(li);
      });
      // quita lo que ya no existe (producto borrado o en borrador)
      if (alive.length !== list.length) { try { localStorage.setItem(KEY, JSON.stringify(alive)); } catch (e) {} }
      sync(); emptyState();
    });
  }

  function start() { sync(); render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
